import _ from 'lodash';
//import { apiSearch, apiFetch} from './utility';
import { apiSearch } from './utility';

const apiBase = 'bulkFormula';

export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};

/*
export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : 'bulkCustomerIds',
			params,
			dispatch,
			successMessage : `Bulk formula created successfully. 
				Click continue to return to the formulas.`,
			onSuccessRedirectTo : `/formulas`,
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			successMessage : `Bulk Formula updated successfully. 
				Click continue to return to the formulas page.`,
			onSuccessRedirectTo : `/formulas`,
			callback,
		});
	};
};
*/